import { Calendar } from "./ui/calendar";

export const WINDOWS = ["Morning · 8AM–12PM", "Afternoon · 12PM–4PM", "Evening · 4PM–7PM"];

export function toISO(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function defaultPickupDate() {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return toISO(d);
}

export function PickupPicker({ date, window, onDate, onWindow, accent = "violet" }) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const max = new Date();
  max.setDate(max.getDate() + 30);
  const selected = date ? new Date(`${date}T00:00:00`) : undefined;
  const selCls = accent === "sage" ? "bg-sage/60 text-charcoal border border-sage" : "bg-violet text-white";

  return (
    <div data-testid="pickup-picker">
      <div className="flex justify-center rounded-2xl bg-white/70 p-1 ring-1 ring-charcoal/5">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(d) => d && onDate(toISO(d))}
          fromDate={today}
          toDate={max}
          disabled={{ before: today }}
        />
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        {WINDOWS.map((w) => (
          <button
            key={w}
            type="button"
            onClick={() => onWindow(w)}
            data-testid={`pickup-window-${w.split(" ")[0]}`}
            className={`rounded-full px-4 py-2 text-sm font-medium transition-all ${window === w ? selCls : "bg-white/70 text-charcoal/65 border border-stone hover:border-violet/40"}`}
          >
            {w}
          </button>
        ))}
      </div>
    </div>
  );
}
